var FieldVisibility;
(function (FieldVisibility) {
    FieldVisibility["BOTH"] = "both";
    FieldVisibility["EDITING"] = "editing";
    FieldVisibility["VIEWING"] = "viewing";
})(FieldVisibility || (FieldVisibility = {}));
var FieldOrientation;
(function (FieldOrientation) {
    FieldOrientation["HORIZONTAL"] = "horizontal";
    FieldOrientation["VERTICAL"] = "vertical";
})(FieldOrientation || (FieldOrientation = {}));
export { FieldOrientation, FieldVisibility, };
//# sourceMappingURL=field-constants.js.map